const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasschang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "370.077,296.108 370.077,315.659 378.335,321.663 339.779,321.663 352.096,317.098  352.096,297.473  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M260.223,321.101v61.587h189.666v-61.587H260.223z M263.323,325.091h152.272v20.13H263.323 V325.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M260.223,321.101v61.587h159.516v-61.587H260.223z M263.323,325.091h152.272v20.13H263.323 V325.091z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.32,
    y: 325.095,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 554.4054 670.315)",
    style: {
      fill: "#E0E0E0"
    },
    width: 27.764,
    height: 20.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.391,
    y: 335.158,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 790.9864 680.3775)",
    style: {
      fill: "#E0E0E0"
    },
    width: 40.204,
    height: 10.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 339.243,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 719.8581 684.4629)",
    style: {
      fill: "#E0E0E0"
    },
    width: 25.858,
    height: 5.977
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.533,
    y: 332.995,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 651.5555 678.2152)",
    style: {
      fill: "#E0E0E0"
    },
    width: 30.49,
    height: 12.226
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "385.325,349.603 386.063,352.008 395.95,352.008 396.688,349.603 415.595,349.603  415.595,376.323 366.417,376.323 366.417,349.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "333.841,349.603 334.579,352.008 344.466,352.008 345.204,349.603 364.111,349.603  364.111,376.323 314.934,376.323 314.934,349.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "282.357,349.603 283.095,352.008 292.982,352.008 293.72,349.603 312.628,349.603  312.628,376.323 263.45,376.323 263.45,349.603  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M288.746,307.79h130.695c1.95,0,3.53-1.581,3.53-3.53v-76.177c0-1.95-1.581-3.53-3.53-3.53 H288.746c-1.95,0-3.53,1.581-3.53,3.53v76.177C285.216,306.21,286.796,307.79,288.746,307.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M285.509,307.79h130.695c1.95,0,3.53-1.581,3.53-3.53v-76.177c0-1.95-1.581-3.53-3.53-3.53 H285.509c-1.95,0-3.53,1.581-3.53,3.53v76.177C281.978,306.21,283.559,307.79,285.509,307.79z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.284,
    y: 201.341,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 617.0275 -84.6843)",
    style: {
      fill: "#F0F0F0"
    },
    width: 75.144,
    height: 129.661
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 323.965,
    y: 83.533,
    style: {
      fill: "#E9E9E9"
    },
    width: 112.616,
    height: 124.616
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.92,
    y: 88.469,
    style: {
      fill: "#F4F4F4"
    },
    width: 103,
    height: 115
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "358.03,88.469 328.92,197.489 328.92,138.469 342.24,88.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "371.04,88.469 340.34,203.469 334.55,203.469 365.25,88.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "431.92,119.829 431.92,178.859 425.4,203.469 409.61,203.469  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.273,
    y: 83.533,
    style: {
      fill: "#E9E9E9"
    },
    width: 4,
    height: 124.616
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.92,
    y: 108.819,
    style: {
      fill: "#E9E9E9"
    },
    width: 108.5,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.805,
    y: 184.307,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -112.9354 299.5514)",
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.827,
    y: 186.37,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -112.9354 299.5514)",
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.02,
    y: 145.357,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -58.771 275.8153)",
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.041,
    y: 147.42,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -58.771 275.8153)",
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.567,
    y: 190.741,
    style: {
      fill: "#E0E0E0"
    },
    width: 27.917,
    height: 39.503
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.387,
    y: 192.599,
    style: {
      fill: "#EBEBEB"
    },
    width: 24.276,
    height: 35.788
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.361,
    y: 138.922,
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.382,
    y: 140.986,
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 185.703,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 381.017 24.7413)",
    style: {
      fill: "#E0E0E0"
    },
    width: 24.277,
    height: 34.352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.582,
    y: 187.319,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 381.0169 24.7414)",
    style: {
      fill: "#EBEBEB"
    },
    width: 21.111,
    height: 31.121
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M63.953,260.514h108.463c4.879,0,8.833,3.955,8.833,8.833l12.007,76.462H67.127L55.12,269.347 C55.12,264.469,59.075,260.514,63.953,260.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M192.933,290.084l-0.135-0.396h42v93h-52v-81.85C182.797,295.042,187.196,290.328,192.933,290.084 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M235.241,290.061L235.241,290.061c5.952,0,10.778,4.825,10.778,10.778v81.85h-21.555v-81.85 C224.464,294.886,229.289,290.061,235.241,290.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M71.933,290.084l-0.136-0.396h42v93h-52v-81.85C61.797,295.042,66.196,290.328,71.933,290.084z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.019,
    y: 317.188,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 342.4451 699.8756)",
    style: {
      fill: "#E0E0E0"
    },
    width: 92.407,
    height: 65.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M107.457,333.188H211.41c6.272,0,11.356-5.084,11.356-11.356v0 c0-6.272-5.084-11.356-11.356-11.356H107.457V333.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M114.241,290.061L114.241,290.061c5.952,0,10.778,4.825,10.778,10.778v81.85h-21.555v-81.85 C103.464,294.886,108.289,290.061,114.241,290.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M84.794,346.941H67.127L55.12,269.347c0-4.879,3.955-8.833,8.833-8.833h0 c4.878,0,8.833,3.955,8.833,8.833L84.794,346.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M59.328,75.477v29.556c0,1.661,1.346,2.766,3.007,2.766h99.816c0,0,11.538-5.382,10.719-12.899 c-0.654-5.998-1.331-10.892-1.887-14.613c-0.684-4.533-4.563-7.817-9.141-7.817H62.335C60.674,72.47,59.328,73.816,59.328,75.477 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6",
      enableBackground: "new"
    },
    d: "M59.328,75.477v29.556c0,1.661,1.346,2.766,3.007,2.766h8.802 c0,0,11.546-5.382,10.719-12.899c-0.654-5.998-1.331-10.892-1.887-14.613c-0.676-4.533-4.563-7.817-9.141-7.817h-8.494 C60.674,72.47,59.328,73.816,59.328,75.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M170.577,97.276H83.382c0,0-2.881,6.389-7.767,9.02h85.19 C160.805,106.296,169.825,102.162,170.577,97.276z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "164.563,103.289 80.375,103.289 81.628,106.296 164.563,106.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "167.57,99.531 83.382,99.531 84.635,102.537 167.57,102.537  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.389,
    y: 95.021,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 174.907 190.9182)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.13,
    height: 0.877
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.397,
    y: 95.021,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.9242 190.9182)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.13,
    height: 0.877
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M113.264,103.989c16.438-16.529,36.998-28.941,59.763-33.392 c29.688-5.805,62.914,3.506,82.181,26.826c25.003,30.263,21.9,73.971,31.667,111.993c2.316,9.016,5.569,18.099,11.837,24.981 c10.403,11.422,27.028,14.654,42.47,15.121c19.373,0.586,43.015-2.02,59.714,9.946c32.074,22.983,11.384,68.889-8.312,92.794 c-27.974,33.952-76.227,47.083-115.346,24.212c-12.367-7.23-23.079-17.643-36.694-22.101c-18.174-5.951-37.899-0.236-57.019-0.635 c-37.745-0.789-71.785-26.242-91.51-58.432c-32.402-52.877-29.325-125.264,7.448-175.201 C103.647,114.423,108.265,109.015,113.264,103.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M113.264,103.989 c16.438-16.529,36.998-28.941,59.763-33.392c29.688-5.805,62.914,3.506,82.181,26.826c25.003,30.263,21.9,73.971,31.667,111.993 c2.316,9.016,5.569,18.099,11.837,24.981c10.403,11.422,27.028,14.654,42.47,15.121c19.373,0.586,43.015-2.02,59.714,9.946 c32.074,22.983,11.384,68.889-8.312,92.794c-27.974,33.952-76.227,47.083-115.346,24.212 c-12.367-7.23-23.079-17.643-36.694-22.101c-18.174-5.951-37.899-0.236-57.019-0.635c-37.745-0.789-71.785-26.242-91.51-58.432 c-32.402-52.877-29.325-125.264,7.448-175.201C103.647,114.423,108.265,109.015,113.264,103.989z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M90.699,344.104c0.21,1.47-3.776,2.438-7.028,2.98c0.265,2.669,2.041,5.366,4.494,7.886 c3.085-1.738,7.49-4.036,8.302-3.475c0.886,0.613-3.624,3.529-6.445,5.244c1.984,1.761,4.218,3.402,6.389,4.84 c1.383-1.292,3.002-2.426,3.967-1.813c1.001,0.637,0.73,2.636,0.236,4.42c3.356,1.957,5.87,3.147,5.87,3.147 s1.409-4.271,2.242-9.53c-0.169-0.334-0.338-0.672-0.492-1.029c-0.541-1.251-0.014-1.784,0.879-1.959 c0.231-2.302,0.298-4.669,0.055-6.866c-3.799-0.797-8.418-2.271-6.688-4.55c1.044-1.374,2.954-1.529,4.942-1.185 c-0.278-0.458-0.586-0.89-0.938-1.278c-6.914-7.618-11.737,0-11.737,0c-4.018-3.348-9.662-2.442-10.882,2.79 C86.121,343.148,90.439,342.288,90.699,344.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M90.699,344.104c0.21,1.47-3.776,2.438-7.028,2.98 c0.265,2.669,2.041,5.366,4.494,7.886c3.085-1.738,7.49-4.036,8.302-3.475c0.886,0.613-3.624,3.529-6.445,5.244 c1.984,1.761,4.218,3.402,6.389,4.84c1.383-1.292,3.002-2.426,3.967-1.813c1.001,0.637,0.73,2.636,0.236,4.42 c3.356,1.957,5.87,3.147,5.87,3.147s1.409-4.271,2.242-9.53c-0.169-0.334-0.338-0.672-0.492-1.029 c-0.541-1.251-0.014-1.784,0.879-1.959c0.231-2.302,0.298-4.669,0.055-6.866c-3.799-0.797-8.418-2.271-6.688-4.55 c1.044-1.374,2.954-1.529,4.942-1.185c-0.278-0.458-0.586-0.89-0.938-1.278c-6.914-7.618-11.737,0-11.737,0 c-4.018-3.348-9.662-2.442-10.882,2.79C86.121,343.148,90.439,342.288,90.699,344.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M99.325,400.09l-0.997-0.082c0.042-0.515,4.094-51.525-7.354-56.334 c-1.229-0.517-2.365-0.488-3.47,0.087c-4.136,2.151-6.119,11.082-6.138,11.173l-0.978-0.213 c0.084-0.386,2.102-9.478,6.653-11.847c1.367-0.711,2.82-0.752,4.32-0.122C103.472,347.839,99.5,397.959,99.325,400.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M100.768,398.985c-0.203-2.295-4.876-56.268,3.862-61.997c2.095-1.373,3.962-1.667,5.549-0.863 c4.129,2.082,4.671,10.91,4.692,11.284l-0.998,0.057c-0.005-0.086-0.529-8.626-4.145-10.449 c-1.244-0.625-2.775-0.356-4.55,0.808c-8.242,5.405-3.463,60.517-3.414,61.073L100.768,398.985z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M102.082,403.348c-0.066-1.757-1.504-43.071,6.452-46.688c1.573-0.715,3.166-0.728,4.732-0.038 c5.46,2.402,8.832,12.577,8.973,13.009l-0.951,0.311c-0.033-0.102-3.374-10.183-8.425-12.404 c-1.313-0.576-2.595-0.567-3.915,0.033c-6.101,2.773-6.304,33.958-5.867,45.74L102.082,403.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M100.057,401.458l-0.993-0.113c1.402-12.296,4.083-45.061-0.297-48.97 c-0.653-0.584-1.238-0.764-1.791-0.554c-2.935,1.126-4.722,11.783-5.163,15.795l-0.994-0.109 c0.169-1.538,1.768-15.073,5.798-16.619c0.922-0.353,1.869-0.105,2.816,0.741C105.092,356.68,100.265,399.632,100.057,401.458z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "83.37,378.148 119.297,378.148 116.297,418.392 86.37,418.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "94.282,378.148 95.282,418.392 116.297,418.392  119.297,378.148  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M88.263,363.38c-0.374,0.979-3.165,0.209-5.356-0.572c-0.752,1.737-0.581,4.009,0.068,6.404 c2.499-0.014,6.003,0.079,6.311,0.703c0.336,0.682-3.445,0.934-5.772,1.025c0.62,1.766,1.435,3.544,2.281,5.175 c1.296-0.323,2.683-0.467,3.068,0.242c0.399,0.736-0.454,1.876-1.37,2.807c1.399,2.357,2.541,3.953,2.541,3.953 s2.333-2.151,4.65-5.108c0.01-0.264,0.022-0.53,0.049-0.803c0.095-0.957,0.603-1.105,1.214-0.907 c0.932-1.34,1.784-2.777,2.388-4.215c-2.07-1.794-4.413-4.287-2.565-5.099c1.115-0.49,2.346,0.069,3.454,0.963 c-0.014-0.378-0.056-0.75-0.14-1.11c-1.652-7.069-7.239-4.024-7.239-4.024c-1.33-3.443-5.122-4.819-7.668-2.01 C85.768,361.221,88.726,362.171,88.263,363.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M88.263,363.38c-0.374,0.979-3.165,0.209-5.356-0.572 c-0.752,1.737-0.581,4.009,0.068,6.404c2.499-0.014,6.003,0.079,6.311,0.703c0.336,0.682-3.445,0.934-5.772,1.025 c0.62,1.766,1.435,3.544,2.281,5.175c1.296-0.323,2.683-0.467,3.068,0.242c0.399,0.736-0.454,1.876-1.37,2.807 c1.399,2.357,2.541,3.953,2.541,3.953s2.333-2.151,4.65-5.108c0.01-0.264,0.022-0.53,0.049-0.803 c0.095-0.957,0.603-1.105,1.214-0.907c0.932-1.34,1.784-2.777,2.388-4.215c-2.07-1.794-4.413-4.287-2.565-5.099 c1.115-0.49,2.346,0.069,3.454,0.963c-0.014-0.378-0.056-0.75-0.14-1.11c-1.652-7.069-7.239-4.024-7.239-4.024 c-1.33-3.443-5.122-4.819-7.668-2.01C85.768,361.221,88.726,362.171,88.263,363.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M114.939,368.158c-1.133,0.084-2.22,0.344-3.283,0.691c-0.277-0.759-0.458-1.55-0.484-2.377 c-0.228-7.246,4.959-4.191,7.7-6.32c1.367-1.062,3.041-1.744,4.585-1.438c-0.231,0.399-0.443,0.812-0.62,1.24 c-0.287,0.694,0.166,1.417,0.877,1.55c0.669,0.125,1.42,0.067,2.035-0.241c0.192-0.096,0.353-0.236,0.523-0.362 c0.383,0.646,0.722,1.439,0.995,2.423c0.279,1.007,0.423,2.051,0.469,3.099c-0.408,0.091-0.813,0.2-1.212,0.342 c-0.623,0.221-0.956,1.218-0.454,1.722c0.441,0.443,0.946,0.795,1.495,1.049c-0.179,1.193-0.512,2.325-0.912,3.396 c-0.123,0.019-0.247,0.033-0.369,0.057c-0.264,0.051-0.524,0.12-0.782,0.193c-0.148,0.042-0.295,0.092-0.434,0.159 c-0.359,0.17-0.621,0.477-0.677,0.879c-0.056,0.395,0.109,0.804,0.427,1.046c0.169,0.129,0.355,0.23,0.539,0.332 c-0.826,1.307-1.803,2.343-2.87,2.896c0,0-1.322-0.577-3.052-1.613c0.216-0.29,0.433-0.58,0.634-0.88 c0.238-0.353,0.343-0.716,0.307-1.138c-0.034-0.409-0.282-0.766-0.587-1.022c-0.294-0.248-0.764-0.356-1.138-0.308 c-0.366,0.047-0.811,0.272-1.022,0.587c-0.24,0.357-0.505,0.696-0.767,1.038c-1.324-0.998-2.641-2.203-3.68-3.574 c0.04-0.012,0.083-0.024,0.11-0.032c0.669-0.175,1.353-0.288,2.042-0.339c0.861-0.064,1.397-0.93,1.33-1.725 C116.592,368.627,115.741,368.098,114.939,368.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M114.939,368.158c-1.133,0.084-2.22,0.344-3.283,0.691 c-0.277-0.759-0.458-1.55-0.484-2.377c-0.228-7.246,4.959-4.191,7.7-6.32c1.367-1.062,3.041-1.744,4.585-1.438 c-0.231,0.399-0.443,0.812-0.62,1.24c-0.287,0.694,0.166,1.417,0.877,1.55c0.669,0.125,1.42,0.067,2.035-0.241 c0.192-0.096,0.353-0.236,0.523-0.362c0.383,0.646,0.722,1.439,0.995,2.423c0.279,1.007,0.423,2.051,0.469,3.099 c-0.408,0.091-0.813,0.2-1.212,0.342c-0.623,0.221-0.956,1.218-0.454,1.722c0.441,0.443,0.946,0.795,1.495,1.049 c-0.179,1.193-0.512,2.325-0.912,3.396c-0.123,0.019-0.247,0.033-0.369,0.057c-0.264,0.051-0.524,0.12-0.782,0.193 c-0.148,0.042-0.295,0.092-0.434,0.159c-0.359,0.17-0.621,0.477-0.677,0.879c-0.056,0.395,0.109,0.804,0.427,1.046 c0.169,0.129,0.355,0.23,0.539,0.332c-0.826,1.307-1.803,2.343-2.87,2.896c0,0-1.322-0.577-3.052-1.613 c0.216-0.29,0.433-0.58,0.634-0.88c0.238-0.353,0.343-0.716,0.307-1.138c-0.034-0.409-0.282-0.766-0.587-1.022 c-0.294-0.248-0.764-0.356-1.138-0.308c-0.366,0.047-0.811,0.272-1.022,0.587c-0.24,0.357-0.505,0.696-0.767,1.038 c-1.324-0.998-2.641-2.203-3.68-3.574c0.04-0.012,0.083-0.024,0.11-0.032c0.669-0.175,1.353-0.288,2.042-0.339 c0.861-0.064,1.397-0.93,1.33-1.725C116.592,368.627,115.741,368.098,114.939,368.158z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M117.012,343.176c0.632-0.453,1.317-0.794,2.028-1.078c-0.188-0.52-0.44-1.015-0.789-1.461 c-3.06-3.906-4.444-0.025-6.818,0.059c-1.184,0.042-2.363,0.419-3.04,1.257c0.297,0.108,0.589,0.232,0.87,0.379 c0.455,0.238,0.535,0.817,0.219,1.199c-0.296,0.359-0.716,0.659-1.175,0.766c-0.143,0.034-0.289,0.031-0.434,0.039 c0.083,0.508,0.252,1.073,0.541,1.71c0.295,0.652,0.678,1.263,1.114,1.833c0.254-0.131,0.515-0.251,0.787-0.352 c0.425-0.157,1.037,0.22,0.994,0.706c-0.037,0.426-0.148,0.833-0.325,1.207c0.618,0.548,1.289,0.997,1.97,1.384 c0.073-0.044,0.144-0.091,0.219-0.132c0.161-0.089,0.328-0.167,0.496-0.242c0.096-0.043,0.195-0.081,0.298-0.107 c0.263-0.068,0.535-0.022,0.742,0.164c0.203,0.183,0.296,0.47,0.235,0.737c-0.032,0.142-0.085,0.277-0.138,0.411 c1.008,0.324,1.976,0.44,2.779,0.262c0,0,0.441-0.883,0.896-2.187c-0.241-0.058-0.482-0.115-0.719-0.184 c-0.28-0.081-0.494-0.225-0.661-0.463c-0.162-0.23-0.188-0.526-0.14-0.795c0.046-0.259,0.245-0.522,0.463-0.661 c0.213-0.136,0.546-0.213,0.795-0.14c0.283,0.082,0.571,0.144,0.858,0.208c0.257-1.105,0.421-2.316,0.365-3.492 c-0.026,0.012-0.054,0.024-0.072,0.031c-0.428,0.202-0.837,0.442-1.222,0.718c-0.48,0.344-1.142,0.124-1.456-0.323 C116.35,344.148,116.565,343.497,117.012,343.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M117.012,343.176c0.632-0.453,1.317-0.794,2.028-1.078 c-0.188-0.52-0.44-1.015-0.789-1.461c-3.06-3.906-4.444-0.025-6.818,0.059c-1.184,0.042-2.363,0.419-3.04,1.257 c0.297,0.108,0.589,0.232,0.87,0.379c0.455,0.238,0.535,0.817,0.219,1.199c-0.296,0.359-0.716,0.659-1.175,0.766 c-0.143,0.034-0.289,0.031-0.434,0.039c0.083,0.508,0.252,1.073,0.541,1.71c0.295,0.652,0.678,1.263,1.114,1.833 c0.254-0.131,0.515-0.251,0.787-0.352c0.425-0.157,1.037,0.22,0.994,0.706c-0.037,0.426-0.148,0.833-0.325,1.207 c0.618,0.548,1.289,0.997,1.97,1.384c0.073-0.044,0.144-0.091,0.219-0.132c0.161-0.089,0.328-0.167,0.496-0.242 c0.096-0.043,0.195-0.081,0.298-0.107c0.263-0.068,0.535-0.022,0.742,0.164c0.203,0.183,0.296,0.47,0.235,0.737 c-0.032,0.142-0.085,0.277-0.138,0.411c1.008,0.324,1.976,0.44,2.779,0.262c0,0,0.441-0.883,0.896-2.187 c-0.241-0.058-0.482-0.115-0.719-0.184c-0.28-0.081-0.494-0.225-0.661-0.463c-0.162-0.23-0.188-0.526-0.14-0.795 c0.046-0.259,0.245-0.522,0.463-0.661c0.213-0.136,0.546-0.213,0.795-0.14c0.283,0.082,0.571,0.144,0.858,0.208 c0.257-1.105,0.421-2.316,0.365-3.492c-0.026,0.012-0.054,0.024-0.072,0.031c-0.428,0.202-0.837,0.442-1.222,0.718 c-0.48,0.344-1.142,0.124-1.456-0.323C116.35,344.148,116.565,343.497,117.012,343.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M87.74,350.428c-0.21,1.47,3.777,2.438,7.028,2.98c-0.265,2.669-2.041,5.366-4.494,7.886 c-3.085-1.738-7.49-4.036-8.302-3.475c-0.886,0.613,3.624,3.529,6.445,5.244c-1.984,1.761-4.218,3.402-6.389,4.84 c-1.383-1.292-3.002-2.426-3.967-1.813c-1.001,0.637-0.73,2.636-0.236,4.42c-3.357,1.957-5.87,3.147-5.87,3.147 s-1.409-4.271-2.242-9.53c0.17-0.334,0.338-0.672,0.492-1.029c0.541-1.251,0.014-1.784-0.879-1.959 c-0.231-2.302-0.297-4.669-0.055-6.866c3.799-0.797,8.418-2.272,6.688-4.55c-1.044-1.374-2.954-1.53-4.942-1.186 c0.278-0.458,0.585-0.89,0.938-1.278c6.914-7.618,11.737,0,11.737,0c4.018-3.349,9.662-2.442,10.882,2.79 C92.318,349.473,88,348.613,87.74,350.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M87.74,350.428c-0.21,1.47,3.777,2.438,7.028,2.98 c-0.265,2.669-2.041,5.366-4.494,7.886c-3.085-1.738-7.49-4.036-8.302-3.475c-0.886,0.613,3.624,3.529,6.445,5.244 c-1.984,1.761-4.218,3.402-6.389,4.84c-1.383-1.292-3.002-2.426-3.967-1.813c-1.001,0.637-0.73,2.636-0.236,4.42 c-3.357,1.957-5.87,3.147-5.87,3.147s-1.409-4.271-2.242-9.53c0.17-0.334,0.338-0.672,0.492-1.029 c0.541-1.251,0.014-1.784-0.879-1.959c-0.231-2.302-0.297-4.669-0.055-6.866c3.799-0.797,8.418-2.272,6.688-4.55 c-1.044-1.374-2.954-1.53-4.942-1.186c0.278-0.458,0.585-0.89,0.938-1.278c6.914-7.618,11.737,0,11.737,0 c4.018-3.349,9.662-2.442,10.882,2.79C92.318,349.473,88,348.613,87.74,350.428z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "385.447,418.392 404.598,291.14 404.598,418.392 409.74,418.392 409.74,290.345  428.911,418.392 434.42,418.392 410.424,258.112 409.74,258.213 409.74,253.001 404.598,253.001 404.598,258.195 403.894,258.112  379.833,418.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "385.447,418.392 404.598,291.14 404.598,418.392  409.74,418.392 409.74,290.345 428.911,418.392 434.42,418.392 410.424,258.112 409.74,258.213 409.74,253.001 404.598,253.001  404.598,258.195 403.894,258.112 379.833,418.392  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "433.518,275.888 380.543,275.888 384.83,231.622 429.23,231.622  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "433.518,275.888 380.543,275.888 384.83,231.622 429.23,231.622  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Fingerprint"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M299.955,218.412h-17.377c-0.771,0-1.399-0.628-1.399-1.399v-41.257 c0.394-0.189,0.671-0.584,0.671-1.05c0-0.647-0.524-1.171-1.171-1.171s-1.172,0.524-1.172,1.171c0,0.466,0.277,0.861,0.672,1.05 v41.257c0,1.323,1.076,2.399,2.399,2.399h17.377c0.772,0,1.399,0.628,1.399,1.399v23.607h1v-23.607 C302.354,219.488,301.278,218.412,299.955,218.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M299.955,218.412h-17.377c-0.771,0-1.399-0.628-1.399-1.399v-41.257 c0.394-0.189,0.671-0.584,0.671-1.05c0-0.647-0.524-1.171-1.171-1.171s-1.172,0.524-1.172,1.171c0,0.466,0.277,0.861,0.672,1.05 v41.257c0,1.323,1.076,2.399,2.399,2.399h17.377c0.772,0,1.399,0.628,1.399,1.399v23.607h1v-23.607 C302.354,219.488,301.278,218.412,299.955,218.412z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M320.843,288.893h-37.978c-1.484,0-2.687-1.203-2.687-2.687v-40.1 c0-1.484,1.203-2.687,2.687-2.687h37.978c1.484,0,2.687,1.203,2.687,2.687v40.1C323.53,287.69,322.327,288.893,320.843,288.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M320.843,288.893h-37.978 c-1.484,0-2.687-1.203-2.687-2.687v-40.1c0-1.484,1.203-2.687,2.687-2.687h37.978c1.484,0,2.687,1.203,2.687,2.687v40.1 C323.53,287.69,322.327,288.893,320.843,288.893z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 243.919,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 243.919,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.678,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.678,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.678,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.678,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M317.934,250.076h5.096v-3.971c0-1.206-0.981-2.187-2.186-2.187h-2.909V250.076z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.678,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 243.919,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.938,
    y: 282.236,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 282.236,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.602,
    y: 282.236,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M285.775,282.236h-5.096v3.97c0,1.206,0.981,2.187,2.187,2.187h2.909V282.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M317.934,282.236v6.157h2.909c1.206,0,2.186-0.981,2.186-2.187v-3.97H317.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M285.775,250.076v-6.157h-2.909c-1.206,0-2.187,0.981-2.187,2.187v3.971H285.775z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 275.904,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 243.919,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 269.572,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 282.236,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 282.236,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 243.919,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.606,
    y: 263.24,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 256.908,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.275,
    y: 250.576,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.21,259.445c-0.09-0.46-0.21-0.91-0.37-1.34c-1.45-4.12-5.38-7.08-9.99-7.08 c-3.33,0-6.31,1.55-8.25,3.97c-0.55,0.69-1.03,1.45-1.39,2.27c-0.6,1.33-0.94,2.8-0.94,4.35v9.08c0,0.89,0.11,1.75,0.32,2.57 c0,0,0,0,0,0.01c0.16,0.65,0.38,1.27,0.67,1.86v0.01c0.25,0.56,0.56,1.09,0.9,1.59c0,0,0,0,0,0.01c0.27,0.36,0.54,0.7,0.83,1.03 c0.36,0.4,0.75,0.77,1.15,1.1c0.34,0.27,0.68,0.53,1.05,0.76c0.62,0.4,1.29,0.73,1.99,1h0.01c0.34,0.12,0.68,0.23,1.03,0.32 c0.44,0.11,0.88,0.19,1.33,0.25c0.34,0.04,0.68,0.07,1.03,0.07c0.09,0.01,0.18,0.01,0.27,0.01c0.55,0,1.1-0.04,1.63-0.12 c0.34-0.06,0.68-0.13,1-0.21h0.01c1.25-0.33,2.41-0.87,3.43-1.59c0.38-0.26,0.73-0.55,1.07-0.86c0.91-0.83,1.68-1.83,2.26-2.94 c0.3-0.56,0.54-1.16,0.73-1.78c0.27-0.88,0.43-1.8,0.45-2.77c0,0,0.01,0,0-0.01c0.01-0.1,0.01-0.21,0.01-0.31v-9.08 C312.44,260.875,312.359,260.145,312.21,259.445z M309.84,275.995c-0.57,0.86-1.27,1.62-2.08,2.25 c-0.3,0.24-0.61,0.45-0.93,0.64c-0.85,0.52-1.77,0.91-2.77,1.15h-0.01c-0.32,0.07-0.65,0.13-0.99,0.17 c-0.4,0.05-0.8,0.08-1.21,0.08c-0.15,0-0.3,0-0.45-0.01c-0.35-0.02-0.68-0.05-1.02-0.1c-0.42-0.07-0.84-0.16-1.24-0.28 c-0.35-0.1-0.69-0.23-1.02-0.36c-0.71-0.31-1.37-0.69-1.98-1.14c-0.33-0.25-0.65-0.52-0.95-0.82c-0.36-0.34-0.69-0.72-0.99-1.12 c-0.29-0.38-0.55-0.79-0.78-1.21v-0.01c-0.34-0.62-0.61-1.28-0.8-1.97c-0.23-0.82-0.35-1.68-0.35-2.57v-9.08 c0-2.19,0.73-4.21,1.97-5.82c0.86-1.12,1.96-2.05,3.22-2.7c1.32-0.69,2.81-1.07,4.39-1.07c4.57,0,8.38,3.19,9.36,7.48 c0,0.01,0,0.01,0,0.02c0.15,0.67,0.23,1.37,0.23,2.09v9.16c-0.01,0.6-0.07,1.19-0.18,1.76v0.01c-0.16,0.79-0.41,1.54-0.75,2.25 C310.319,275.215,310.09,275.615,309.84,275.995z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.059,267.235c-1.07,3.39-2.46,7.85-1.66,13.04c0.05,0.33,0.11,0.66,0.18,1 c-0.35,0-0.69-0.03-1.03-0.07c-0.07-0.35-0.13-0.69-0.17-1.03c-0.76-5.3,0.65-9.81,1.72-13.24c1.14-3.64,1.61-5.42-0.11-6.15 c-0.54-0.23-1.08-0.16-1.65,0.22c-2.73,1.81-5.17,9.62-6.14,15.45c-0.08,0.46-0.15,0.9-0.21,1.32 c-0.29-0.33-0.56-0.67-0.83-1.03c0-0.01,0-0.01,0-0.01c0.07-0.48,0.16-0.98,0.26-1.49v-0.01c1.1-5.78,3.45-13.13,6.37-15.06 c0.85-0.56,1.75-0.67,2.59-0.31C305.009,260.985,304.15,263.745,303.059,267.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.319,266.985c-1,3.21-2.47,7.91-2.18,12.91c0.02,0.35,0.04,0.7,0.08,1.06 c-0.35-0.09-0.69-0.2-1.03-0.32h-0.01c-0.03-0.37-0.05-0.73-0.06-1.1c-0.2-5.01,1.25-9.66,2.25-12.85 c0.4-1.27,0.85-2.7,0.84-3.25c-1.21,1.08-4.96,9.88-5.07,14.96c-0.02,0.45,0,0.86,0.05,1.24c-0.37-0.23-0.71-0.49-1.05-0.76 c0-0.41,0.01-0.85,0.05-1.3c0.42-5.3,3.61-13.29,5.35-14.87c0.46-0.42,0.84-0.4,1.07-0.31 C302.639,262.795,302.169,264.285,301.319,266.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.059,280.035c0.13,0.34,0.28,0.65,0.42,0.92c-0.32,0.08-0.66,0.15-1,0.21 c-0.15-0.29-0.29-0.61-0.42-0.96c-0.82-2.14-1.25-5.39,0.24-9.83c2.91-8.66,2.4-10.72,0.24-11.86c-1.24-0.66-2.47-0.7-3.66-0.12 c-2.99,1.48-5.59,6.83-7.26,14.87c-0.13,0.61-0.25,1.23-0.36,1.87c-0.29-0.59-0.51-1.21-0.67-1.86c0-0.01,0-0.01,0-0.01 c0.21-1.03,0.44-2.02,0.68-2.96c1.74-6.88,4.23-11.35,7.17-12.8c1.49-0.74,3.03-0.7,4.57,0.12c3.01,1.6,3.07,4.65,0.24,13.06 c-1.45,4.32-0.98,7.4-0.2,9.35H304.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.989,278.505c-0.34,0.31-0.69,0.6-1.07,0.86c-0.14-0.04-0.27-0.08-0.41-0.13 c-0.24-0.09-0.47-0.2-0.68-0.35c-1.04-0.62-1.8-1.73-2.21-3.23c-0.52-1.87,0.33-4.57,1.24-7.42c0.91-2.87,1.85-5.83,1.4-7.98 c-0.36-1.74-1.27-3.02-2.63-3.71c-1.75-0.87-4.08-0.72-6.55,0.43c-2.6,1.22-4.59,4.83-5.81,7.68c-0.43,1.01-0.77,1.92-1,2.59 v-2.81c0.29-0.68,0.62-1.42,1-2.16c1.29-2.53,3.1-5.14,5.38-6.2c2.76-1.29,5.4-1.44,7.43-0.42c1.64,0.83,2.74,2.35,3.16,4.4 c0.5,2.4-0.48,5.49-1.43,8.48c-0.86,2.71-1.67,5.26-1.23,6.85c0.41,1.44,1.15,2.43,2.18,2.86c0.03,0.02,0.07,0.04,0.11,0.05 C308.219,278.435,308.599,278.505,308.989,278.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.98,273.785c-0.19,0.62-0.43,1.22-0.73,1.78c-0.5,0.25-0.97,0.39-1.41,0.43 c-0.1,0.01-0.19,0.01-0.28,0.01c-0.08,0-0.17-0.01-0.25-0.02c-1.11-0.1-1.96-0.83-2.3-1.95c-0.44-1.49,0.28-4.29,1.04-7.25 c0.55-2.14,1.12-4.36,1.12-5.75c0-3.08-0.8-6.38-6.71-7.43c-3.01-0.54-7.32,1.381-9.853,5.483 c-0.494,0.8,0.153-2.273-0.397-1.823c0.36-0.82,0.919-0.778,1.469-1.468c1.11-0.72,4.203-3.772,8.951-3.182 c6.815,0.847,7.54,5.38,7.54,8.42c0,1.52-0.56,3.7-1.16,6c-0.66,2.57-1.4,5.49-1.04,6.72c0.22,0.72,0.74,1.18,1.43,1.24 c0.32,0.03,0.7-0.03,1.11-0.2C310.969,274.615,311.48,274.285,311.98,273.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.44,268.345v2.35c0,0.1,0,0.21-0.01,0.31c0.01,0.01,0,0.01,0,0.01 c-0.35,0.68-0.73,1.2-1.17,1.52v0.01c-0.35,0.25-0.74,0.38-1.19,0.38c-0.09,0-0.19,0-0.29-0.01c-0.31-0.04-0.56-0.22-0.71-0.51 c-0.45-0.83,0.107-2.501,0.48-3.44c1.37-3.455,1.865-6.063,1.66-9.44c0-0.01,0-0.01,0-0.02c0.04-0.57,0.06-0.92,0.06-0.94 c0.02-0.27,0.26-0.48,0.53-0.47c0.01,0,0.03,0,0.04,0.01c0.16,0.43,0.28,0.88,0.37,1.34c-0.05,0.74-0.12,1.48-0.19,2.22 c-0.14,1.42-0.31,2.84-0.58,4.25c-0.07,0.38,0.253,0.233,0.173,0.613c-0.13,0.56-0.653,1.667-0.883,2.197 c-0.24,0.55-0.51,1.09-0.7,1.66c-0.12,0.34-0.56,1.94,0.34,1.59c0.34-0.13,0.61-0.48,0.81-0.77c0.09-0.14,0.18-0.28,0.26-0.43 c0.3-0.53,0.53-1.12,0.74-1.69C312.27,268.845,312.359,268.595,312.44,268.345z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Iris_Recognition"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M238.706,98.729v25.5c0,0.771-0.628,1.399-1.399,1.399h-25.927 c-0.188-0.394-0.583-0.672-1.05-0.672c-0.647,0-1.171,0.525-1.171,1.172c0,0.647,0.524,1.172,1.171,1.172 c0.466,0,0.861-0.277,1.05-0.672h25.927c1.323,0,2.399-1.076,2.399-2.399v-25.5H238.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M238.706,98.729v25.5c0,0.771-0.628,1.399-1.399,1.399h-25.927 c-0.188-0.394-0.583-0.672-1.05-0.672c-0.647,0-1.171,0.525-1.171,1.172c0,0.647,0.524,1.172,1.171,1.172 c0.466,0,0.861-0.277,1.05-0.672h25.927c1.323,0,2.399-1.076,2.399-2.399v-25.5H238.706z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M216.469,103.981V66.003c0-1.484,1.203-2.687,2.687-2.687h40.1c1.484,0,2.687,1.203,2.687,2.687 v37.978c0,1.484-1.203,2.687-2.687,2.687h-40.1C217.671,106.668,216.469,105.465,216.469,103.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M216.469,103.981V66.003c0-1.484,1.203-2.687,2.687-2.687 h40.1c1.484,0,2.687,1.203,2.687,2.687v37.978c0,1.484-1.203,2.687-2.687,2.687h-40.1 C217.671,106.668,216.469,105.465,216.469,103.981z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.285,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.285,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 63.817,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 63.817,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 63.817,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 63.817,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M255.285,101.072v5.096h3.971c1.206,0,2.186-0.981,2.186-2.187v-2.909H255.285z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 63.817,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 101.072,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.285,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.969,
    y: 82.077,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.969,
    y: 88.409,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 101.072,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.969,
    y: 94.74,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 101.072,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M223.126,68.913v-5.096h-3.97c-1.206,0-2.187,0.981-2.187,2.187v2.909H223.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M223.126,101.072h-6.157v2.909c0,1.206,0.981,2.187,2.187,2.187h3.97V101.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M255.285,68.913h6.157v-2.909c0-1.206-0.981-2.187-2.186-2.187h-3.971V68.913z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 101.072,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 101.072,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.626,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.285,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.958,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.969,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.969,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.285,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 6.157,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 75.745,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.622,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.954,
    y: 69.413,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M226.019,84.81 c0,0,5.904,7.013,13.187,7.013c7.283,0,13.187-7.013,13.187-7.013s-5.904-7.013-13.187-7.013 C231.923,77.797,226.019,84.81,226.019,84.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M243.798,83.81c0,2.536-2.056,4.592-4.593,4.592 c-2.536,0-4.592-2.056-4.592-4.592c0-2.536,2.056-4.593,4.592-4.593C241.742,79.218,243.798,81.274,243.798,83.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M239.72,81.789c0-0.821,0.665-1.486,1.486-1.486 c0.821,0,1.486,0.665,1.486,1.486s-0.665,1.486-1.486,1.486C240.385,83.275,239.72,82.61,239.72,81.789z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.205,
    y1: 77.797,
    x2: 239.205,
    y2: 73.098
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.3,
    y1: 78.136,
    x2: 244.982,
    y2: 74.323
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 247.227,
    y1: 79.878,
    x2: 249.581,
    y2: 77.091
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 250.378,
    y1: 82.031,
    x2: 252.647,
    y2: 80.515
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 235.111,
    y1: 78.136,
    x2: 233.428,
    y2: 74.323
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 231.184,
    y1: 79.878,
    x2: 228.829,
    y2: 77.091
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 228.033,
    y1: 82.031,
    x2: 225.764,
    y2: 80.515
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Face_Recognition"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M171.242,127.213c-0.457,0-0.843,0.269-1.036,0.651H143.65c-1.323,0-2.4,1.077-2.4,2.4v27.284 c0,0.771-0.628,1.4-1.399,1.4h-10.683v1h10.683c1.323,0,2.399-1.076,2.399-2.4v-27.284c0-0.772,0.628-1.4,1.4-1.4h26.529 c0.184,0.406,0.588,0.692,1.063,0.692c0.647,0,1.172-0.524,1.172-1.171S171.889,127.213,171.242,127.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M171.242,127.213c-0.457,0-0.843,0.269-1.036,0.651H143.65c-1.323,0-2.4,1.077-2.4,2.4 v27.284c0,0.771-0.628,1.4-1.399,1.4h-10.683v1h10.683c1.323,0,2.399-1.076,2.399-2.4v-27.284c0-0.772,0.628-1.4,1.4-1.4h26.529 c0.184,0.406,0.588,0.692,1.063,0.692c0.647,0,1.172-0.524,1.172-1.171S171.889,127.213,171.242,127.213z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M126.481,182.185H88.503c-1.484,0-2.687-1.203-2.687-2.687v-40.1c0-1.484,1.203-2.687,2.687-2.687 h37.978c1.484,0,2.687,1.203,2.687,2.687v40.1C129.168,180.982,127.965,182.185,126.481,182.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M126.481,182.185H88.503c-1.484,0-2.687-1.203-2.687-2.687 v-40.1c0-1.484,1.203-2.687,2.687-2.687h37.978c1.484,0,2.687,1.203,2.687,2.687v40.1 C129.168,180.982,127.965,182.185,126.481,182.185z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 137.211,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 137.211,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.316,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.316,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.316,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.316,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M123.572,143.368h5.096v-3.971c0-1.206-0.981-2.186-2.187-2.186h-2.909V143.368z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.316,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 137.211,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.576,
    y: 175.527,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.908,
    y: 175.527,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.24,
    y: 175.527,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M91.412,175.527h-5.096v3.97c0,1.206,0.981,2.187,2.187,2.187h2.909V175.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M123.572,175.527v6.157h2.909c1.206,0,2.187-0.981,2.187-2.187v-3.97H123.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M91.412,143.368v-6.157h-2.909c-1.206,0-2.187,0.981-2.187,2.186v3.971H91.412z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.096,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 169.195,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 137.211,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 162.864,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 175.527,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 175.527,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 137.211,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 6.157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.244,
    y: 156.532,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 150.2,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.912,
    y: 143.868,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 5.832,
    height: 5.832
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M107.492,174.579c-5.838,0-10.588-4.75-10.588-10.588v-9.085c0-5.838,4.75-10.588,10.588-10.588 c5.838,0,10.588,4.75,10.588,10.588v9.085C118.08,169.829,113.33,174.579,107.492,174.579z M107.492,145.317 c-5.287,0-9.588,4.301-9.588,9.588v9.085c0,5.287,4.301,9.588,9.588,9.588c5.287,0,9.588-4.301,9.588-9.588v-9.085 C117.08,149.618,112.779,145.317,107.492,145.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 112.272,
    cy: 156.685,
    rx: 1.121,
    ry: 1.516
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.832,156.685c0,0.838-0.502,1.517-1.121,1.517c-0.619,0-1.121-0.679-1.121-1.517 c0-0.837,0.502-1.516,1.121-1.516C103.331,155.169,103.832,155.848,103.832,156.685z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "107.547,158.202 105.437,163.609 107.547,163.609  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M107.108,167.365c-1.847,0-2.745-0.415-2.799-0.442l0.433-0.901l-0.216,0.451l0.212-0.453 c0.018,0.009,1.789,0.793,5.616-0.036l0.212,0.978C109.171,167.263,108.023,167.365,107.108,167.365z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Interface"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M397.976,189.503H289.025c-2.832,0-5.129-2.296-5.129-5.129V75.423 c0-2.832,2.296-5.129,5.129-5.129h108.951c2.833,0,5.129,2.296,5.129,5.129v108.951 C403.105,187.207,400.808,189.503,397.976,189.503z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M385.645,168.448h-84.289c-2.556,0-4.628-2.072-4.628-4.628v-15.422 c0-2.556,2.072-4.628,4.628-4.628h84.289c2.556,0,4.628,2.072,4.628,4.628v15.422 C390.273,166.376,388.201,168.448,385.645,168.448z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M313.447,156.121l2.73,1.478l-1.227,2.054l-2.755-1.628l0.05,3.031h-2.354l0.025-3.056 l-2.755,1.653l-1.202-2.054l2.73-1.478l-2.73-1.503l1.202-2.053l2.755,1.653l-0.025-3.055h2.354l-0.05,3.055l2.755-1.653 l1.227,2.053L313.447,156.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M329.663,156.122l2.73,1.477l-1.227,2.054l-2.755-1.628l0.05,3.03h-2.354l0.025-3.055 l-2.755,1.653l-1.202-2.054l2.73-1.477l-2.73-1.503l1.202-2.053l2.755,1.653l-0.025-3.055h2.354l-0.05,3.055l2.755-1.653 l1.227,2.053L329.663,156.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.879,156.121l2.73,1.477l-1.227,2.054l-2.755-1.628l0.05,3.03h-2.354l0.025-3.055 l-2.755,1.653l-1.202-2.054l2.73-1.477l-2.73-1.503l1.202-2.054l2.755,1.653l-0.025-3.056h2.354l-0.05,3.056l2.755-1.653 l1.227,2.054L345.879,156.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M362.096,156.121l2.73,1.478l-1.227,2.053l-2.755-1.628l0.05,3.031h-2.354l0.025-3.056 l-2.755,1.653l-1.202-2.053l2.73-1.478l-2.73-1.503l1.202-2.054l2.755,1.653l-0.025-3.056h2.354l-0.05,3.056l2.755-1.653 l1.227,2.054L362.096,156.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M378.313,156.122l2.73,1.477l-1.227,2.054l-2.755-1.628l0.05,3.03h-2.354l0.025-3.055 l-2.755,1.653l-1.202-2.054l2.73-1.477l-2.73-1.503l1.202-2.053l2.755,1.653l-0.025-3.055h2.354l-0.05,3.055l2.755-1.653 l1.227,2.053L378.313,156.122z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 24.8212 274.2837)",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    cx: 343.5,
    cy: 107.18,
    rx: 26.735,
    ry: 26.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.954,105.681h-20.909c-1.582,0-2.864,1.282-2.864,2.864v12.736 c0,1.582,1.283,2.864,2.864,2.864h20.909c1.582,0,2.865-1.282,2.865-2.864v-12.736 C356.819,106.963,355.537,105.681,353.954,105.681z M345.423,119.849h-3.846l0.806-5.205c-0.841-0.415-1.426-1.272-1.426-2.274 c0-1.405,1.139-2.543,2.543-2.543c1.405,0,2.543,1.139,2.543,2.543c0,1.002-0.584,1.859-1.426,2.274L345.423,119.849z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M337.485,103.64l-0.393-1.959c-0.699-3.481,1.564-6.881,5.045-7.581 c3.481-0.699,6.881,1.564,7.581,5.045l0.393,1.959l3.685-0.74l-0.394-1.959c-1.107-5.513-6.493-9.097-12.006-7.99 c-5.513,1.107-9.097,6.493-7.99,12.006l0.393,1.959L337.485,103.64z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M358.398,177.343h-29.796c-0.728,0-1.319-0.59-1.319-1.319l0,0 c0-0.728,0.59-1.319,1.319-1.319h29.796c0.728,0,1.319,0.59,1.319,1.319l0,0C359.717,176.753,359.126,177.343,358.398,177.343z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__83_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M259.692,176.791l10.24-8.703c0,0,8.716-9.239,10.562-9.438c1.846-0.199,5.802,0.592,6.857,1.911 c1.055,1.319-6.824,9.9-8.67,11.483c-1.846,1.582-5.538,1.319-5.538,1.319l-9.758,9.431L259.692,176.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M180.69,409.115h-9.899c-0.334,0.002-0.622,0.234-0.695,0.56l-1.607,7.256 c-0.137,0.65,0.278,1.288,0.928,1.425c0.087,0.018,0.176,0.027,0.265,0.026c3.203-0.052,5.535-0.249,9.557-0.249 c2.477,0,9.951,0.259,13.372,0.259c3.421,0,3.866-3.379,2.467-3.69c-6.282-1.368-11.008-3.265-13.019-5.069 C181.686,409.291,181.196,409.105,180.69,409.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.671,408.855h-9.899c-0.334,0.002-0.622,0.234-0.695,0.56l-1.607,7.256 c-0.137,0.65,0.278,1.288,0.927,1.425c0.087,0.018,0.176,0.027,0.264,0.026c3.203-0.052,5.535-0.249,9.557-0.249 c2.477,0,9.951,0.259,13.372,0.259c3.421,0,3.866-3.379,2.467-3.69c-6.282-1.368-11.008-3.265-13.019-5.069 C223.666,409.032,223.176,408.846,222.671,408.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M175.44,225.615h43.249c4.113,22.455,15.873,113.33,6.638,184.132l-14.439,1.583 c0,0,2.264-108.803-10.663-143.551c-1.487,18.596-3.252,38.383-4.785,48.912c-3.763,25.914-12.244,93.452-12.244,93.452 l-14.637,0.396c0,0,3.207-65.508,4.616-90.976C174.715,291.913,175.381,231.294,175.44,225.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M175.44,225.615h43.249 c4.113,22.455,15.873,113.33,6.638,184.132l-14.439,1.583c0,0,2.264-108.803-10.663-143.551 c-1.487,18.596-3.252,38.383-4.785,48.912c-3.763,25.914-12.244,93.452-12.244,93.452l-14.637,0.396 c0,0,3.207-65.508,4.616-90.976C174.715,291.913,175.381,231.294,175.44,225.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M200.229,267.783c1.907,5.121,3.493,11.516,4.831,18.71 c1.209-16.548-3.628-34.099-3.628-34.099L200.229,267.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M214.741,150.786c6.829,0.83,20.279,31.885,25.422,34.654 c5.143,2.769,25.517-14.637,25.517-14.637l5.143,6.33c0,0-23.143,24.725-32.242,21.956c-9.099-2.769-21.956-26.11-25.912-33.429 C208.712,158.341,214.741,150.786,214.741,150.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M270.82,177.135c0,0-23.14,24.72-32.24,21.95 c-3.97-1.21-8.66-6.34-13.01-12.34c-5.62-7.75-10.67-16.96-12.9-21.08c-2.13-3.93-1.37-7.94-0.22-10.8 c1-2.46,2.29-4.08,2.29-4.08c6.83,0.83,20.28,31.89,25.42,34.66c5.15,2.76,25.52-14.64,25.52-14.64L270.82,177.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M225.57,186.744c-5.62-7.75-10.67-16.96-12.9-21.08 c-2.13-3.93-1.37-7.94-0.22-10.8C216.34,159.654,224.25,171.154,225.57,186.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M214.743,150.786c0,0-27.512-1.296-48.008,3.878c0,0,7.685,59.51,7.341,85.424l49.055-2.637 C223.132,237.451,221.888,177.53,214.743,150.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M174.08,240.09c0.16-12.05-1.42-31.36-3.15-48.58v-0.01 c-0.66-6.57-1.34-12.84-1.96-18.28c-1.25-10.95-2.23-18.56-2.23-18.56c20.49-5.17,48-3.87,48-3.87 c7.15,26.74,8.39,86.66,8.39,86.66L174.08,240.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M170.93,191.5c-0.66-6.57-1.34-12.84-1.96-18.28l3.15-2.42 C172.12,170.8,174.86,181.64,170.93,191.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M214.38,215.02l-2.69,0.13l-7.3,0.34l-4.48,0.21l-9.33,0.44 c0,0-0.02-0.46-0.05-1.3v-0.01c-0.08-1.81-0.24-5.39-0.51-9.9v-0.01c-0.19-3.36-0.45-7.24-0.77-11.3 c-0.23-2.8-0.48-5.68-0.77-8.53c-0.43-4.23-0.93-8.41-1.52-12.17c-0.31-2.02-0.65-3.91-1.01-5.63l23.21-1.51 c0,0,0.3,1.47,0.75,4.04c0.3,1.66,0.66,3.78,1.05,6.26C212.47,185.73,214.38,200.78,214.38,215.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M204.39,215.49l-4.48,0.21c3.19-8.11,4.44-19.54,2.3-23.1 c-2.9-4.82-6.46,4.42-8.98,15.5c-0.69,3.02-1.65,5.18-2.7,6.73c-0.08-1.81-0.24-5.39-0.51-9.9v-0.01 c1.1-1.72,2.22-4.16,3.21-7.63c3.57-12.53,6.74-14.77,10.82-11.48C207.79,188.83,208.89,203.43,204.39,215.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M211.69,215.15c0.91-10.63-0.49-28.54-3.61-34.05 c-3.57-6.32-11.45-6.46-15.24,4.97c-1.13,3.39-2.38,5.81-3.59,7.55c-0.23-2.8-0.48-5.68-0.77-8.53 c0.88-1.08,1.84-2.47,2.85-4.25c4.32-7.65,11.05-11.21,17.6-6.76c0.73,0.5,1.41,1.17,2.03,2c1.51,9.65,3.42,24.7,3.42,38.94 L211.69,215.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M209.91,169.82c-5.19-3.92-12.2-2.86-16.68,0.85 c-2.32,1.92-4.52,2.37-6.27,2.25c-0.31-2.02-0.65-3.91-1.01-5.63l23.21-1.51C209.16,165.78,209.46,167.25,209.91,169.82z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M182.799,152.598c3.95,3.589,13.629,2.262,13.629,2.262s6.041-1.654,4.772-3.541 c-3.558-0.588-5.281-2.249-5.993-4.373c-0.413-1.238-0.475-2.63-0.361-4.064c0.052-0.753,0.165-1.516,0.299-2.269l-11.964-8.86 C184.749,137.601,186.667,148.359,182.799,152.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M185.945,137.384c0.474,7.179,6.374,9.159,9.262,9.561 c-0.413-1.238-0.475-2.63-0.361-4.064L185.945,137.384z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M203.432,113.149c0,0,3.338,10.798-1.889,15.928c-5.227,5.13-8.314-15.44-8.314-15.44 L203.432,113.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M185.833,140.414c3.459,3.663,8.261,4.038,12.099,2.158c2.468-1.205,4.535-3.351,5.596-6.148 c0.144-0.366,0.263-0.749,0.371-1.14c1.873-7.186,1.019-19.135-6.785-22.491c-5.548-2.432-12.032,0.095-14.462,5.654 c-0.702,1.576-1.007,3.301-0.914,5.029C182.045,131.502,181.848,136.236,185.833,140.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M193.88,125.967c-0.058,0.647,0.317,1.188,0.751,1.196c0.434,0.008,0.782-0.52,0.799-1.171 c0.017-0.651-0.328-1.189-0.752-1.197C194.255,124.789,193.898,125.306,193.88,125.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M201.271,126.116c-0.058,0.647,0.328,1.189,0.752,1.197c0.424,0.007,0.782-0.52,0.799-1.171 c0.017-0.651-0.328-1.189-0.752-1.197C201.646,124.938,201.285,125.496,201.271,126.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D58745"
    },
    d: "M198.916,126.39c0.738,2.015,1.751,3.919,3.011,5.657c-0.922,0.632-2.077,0.823-3.154,0.523 L198.916,126.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M191.635,123.527c0.142,0.023,0.285-0.031,0.375-0.142c0.586-0.781,1.507-1.239,2.483-1.236 c0.21,0.02,0.396-0.135,0.415-0.345c0.019-0.21-0.135-0.396-0.345-0.415c-0.001,0-0.001,0-0.002,0 c-1.234-0.035-2.409,0.531-3.151,1.518c-0.135,0.162-0.114,0.402,0.047,0.538c0.002,0.002,0.005,0.004,0.007,0.006 C191.518,123.484,191.575,123.51,191.635,123.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M204.498,123.632c0.071,0.03,0.15,0.037,0.226,0.021c0.193-0.085,0.28-0.311,0.195-0.503 c-0.001-0.003-0.002-0.005-0.003-0.008c-0.493-1.137-1.508-1.962-2.721-2.213c-0.209-0.031-0.402,0.114-0.433,0.322l0,0.001 c-0.025,0.208,0.117,0.398,0.323,0.433l0,0c0.952,0.226,1.741,0.889,2.128,1.787C204.28,123.564,204.384,123.623,204.498,123.632 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M187.831,113.578l0.529,3.527c-1.144,0.65-1.808,1.979-1.234,3.358 c1.224,2.945-0.338,7.608-2.571,9.512c0,0-0.106-1.288-1.186-0.952c-1.08,0.336-0.595,7.043,1.615,10.187 c0,0-3.838-3.441-5.844-10.44c-1.856-6.474-1.665-11.27-0.395-13.829L187.831,113.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.367,134.534c-0.413,0.997-0.787,2.851-0.787,2.851c-0.174-0.004-0.348-0.007-0.522-0.02 c-2.359-0.109-3.417-0.938-3.875-1.825c-0.249-0.486-0.312-0.995-0.31-1.408c-0.002-0.477,0.106-0.818,0.106-0.818 c1.216,0.805,3.408,1.075,4.584,1.171C199.056,134.529,199.367,134.534,199.367,134.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.563,134.484l-0.254,0.835c-2.222-0.108-3.771-0.482-4.436-1.187 c-0.002-0.477,0.106-0.818,0.106-0.818C195.195,134.118,197.387,134.389,198.563,134.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M198.059,137.364c-2.359-0.109-3.417-0.938-3.875-1.825c0.802,0.068,1.762,0.239,2.595,0.64 C197.417,136.483,197.807,136.924,198.059,137.364z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M193.116,115.769c0,0,0.625-1.088,2.315-0.593c1.69,0.495,3.183,2.195,4.918,4.352 c1.736,2.157,5.178,2.176,5.969,0.89c0.791-1.286-0.791-3.066-0.791-3.066s1.48-8.209-7.469-10.088 c-8.949-1.879-13.655,2.077-13.655,2.077s-7.436,0.245-7.953,7.121c-0.336,4.462,0.495,8.335,0.495,8.335 s-1.978,2.516,1.769,2.367c4.266-0.17,9.391-2.493,9.646-6.647C188.615,116.363,193.116,115.769,193.116,115.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M178.097,129.988c0.854,1.835,2.401,3.256,4.301,3.952c2.523,0.904,3.975-1.309,3.44-3.793 c-0.496-2.203-2.392-5.401-5.007-5.208C178.215,125.132,177.077,127.723,178.097,129.988z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M166.736,154.664c-7.164,2.083-17.186,50.875-15.867,57.204 c1.319,6.33,26.503,32.967,26.503,32.967l7.033-5.303c0,0-21.404-30.302-21.667-36.632c-0.264-6.33,9.495-29.802,9.495-29.802 s-0.264-7.912-1.319-11.868C169.857,157.275,166.736,154.664,166.736,154.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M166.736,154.664 c-7.164,2.083-17.186,50.875-15.867,57.204c1.319,6.33,26.503,32.967,26.503,32.967l7.033-5.303c0,0-21.404-30.302-21.667-36.632 c-0.264-6.33,9.495-29.802,9.495-29.802s-0.264-7.912-1.319-11.868C169.857,157.275,166.736,154.664,166.736,154.664z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasschang);
export default __webpack_public_path__ + "static/media/passchang.ba24a66e0788fc8783e4a2c038b93481.svg";
export { ForwardRef as ReactComponent };